<template>
  <div>
    <FixedButton>
      <el-button type="primary" @click.stop="add" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <AccountEdit
      :row="row"
      :roleList="roleList"
      v-if="visible"
      @refresh="formSearch"
      :visible.sync="visible"
    />
    <AccountDetail
      :row="row"
      @refresh="formSearch"
      v-if="detailVisible"
      :visible.sync="detailVisible"
    />
  </div>
</template>

<script>
import formjson from './Model/Formjson.Account'
import tablejson from './Model/Tablejson.Account'
import formTableMixin from '@manage/mixins/formTableMixin'
// import getRoleFromPath from '@manage/mixins/getRoleFromPath'
// import { getRoleByOperationCode } from '@manage/authorized'
import AccountEdit from './AccountEdit'
import AccountDetail from './AccountDetail'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit'
        },
        {
          name: '删除',
          type: 'delete',
          hide: (row) => {
            return row.state === 'enable'
          }
        },
        {
          name: '重置密码',
          type: 'reset'
        }
      ],
      queryApi: this.$api.system.user_list,
      visible: false,
      detailVisible: false,
      row: {},
      roleList: []
    }
  },
  components: {
    AccountEdit,
    AccountDetail
  },
  computed: {
    accountType() {
      return this.$store.state.accountType
    }
  },
  mounted() {
    // 角色下拉框
    this.$ajax.get(this.$api.common.role_select).then((res) => {
      this.roleList = res.data
    })
  },
  methods: {
    formSearch(data) {
      this.search(data, null, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDetail(row) {
      this.row = row
      this.detailVisible = true
    },
    handleReset(row) {
      this.$confirm('是否重置该用户密码为123456?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id,
            pwd: '123456'
          }
          this.$ajax
            .post(this.$api.system.user_reset, params)
            .then(() => {
              this.$message.success('重置成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDelete(row) {
      this.$confirm('是否删除该用户?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.system.user_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'reset':
          this.handleReset(row)
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.el-table {
  .system-defined {
    background: #f0f9eb;
  }
}
</style>
